export default "__VITE_ASSET__BeTnzusz__"